import Vue from 'vue'
import Vuex, {
  Store
} from 'vuex'
import objectToFormData from 'object-to-formdata'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoadings: false,
    isLogin: false,
    isLoginWithNip: false,
    access_token: localStorage.getItem('AZDFDdsSDSJ21SSDO') || null,
    access_token_vip: localStorage.getItem('ADSDIS458SZDF54S7') || null,
    access_token_with_nip: localStorage.getItem('IJIFS7854KOKSDOKO') || null,
    website: [],
    pages: [],
    status: [],
    sections: [],
    demande: [],
    galeriItem: [],
    message: [],
    usersForSite: [],
    wilaya: [],
    commune: [],
    news: [],
    itemBarNew: [],
    users: [],
    quastion: [],
    result: [],
    resultwithNip: [],
    cartFidaliti: [],
    settings: [],
  },
  getters: {
    getWebsite: state => {
      return state.website.filter(e => e.idPage == 4)
    }
  },
  mutations: {
    getCommune(state, data) {
      state.isLoadings = true
      axios.get(USER_BACKEND_URL + 'getCommune').then(res => {
        state.commune = res.data
        state.isLoadings = false
      })
    },

    getWilaya(state, data) {
      state.isLoadings = true
      axios.get(USER_BACKEND_URL + 'getWilaya').then(res => {
        state.wilaya = res.data
        state.isLoadings = false
      })
    },
    getSettings(state, data) {
      state.isLoadings = true
      axios.post(BACKEND_URL + "getSettings", {
        domainName: document.location.origin
      }, {
        headers: {
          "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
        }
      }).then((res) => {
        state.isLoadings = false
        return state.settings = res.data
      })
    },
    getItemBarNew(state, data) {
      this.isLoadings = true
      axios.post(BACKEND_URL + 'getItemBarAndCheck', {
        domainName: document.location.origin
      }).then((res) => {
        state.itemBarNew = res.data
        state.isLoadings = false
      })
    },
    getMessage(state, data) {
      axios.post(BACKEND_URL + "getMessage", {
        domainName: document.location.origin
      }, {
        headers: {
          "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
        }
      }).then((res) => {
        state.message = res.data
      })
    },
    sendResponse(state, data) {
      axios.post(BACKEND_URL + "getDemandes/sendResponse", data, {
        headers: {
          "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
        },
        transformRequest: [function (dat, headers) {
          return objectToFormData(dat)
        }],
        onUploadProgress: e => {}
      }).then((data) => {
        this.commit('getDemandes')

        localStorage.getItem('lang') == 'fr' ? toastr.success("Devis envoyée avec succès", "succès") : toastr.success("تم إرسال التسعيرة بنجاح ", "نجاح")
        this.commit('getDemandes')
        res(data.data)
      }, () => {
        this.commit('getDemandes')
      })
    },
    saveCartFidaliti(state, data) {
      axios.post(USER_BACKEND_URL + "saveCartFidaliti", data, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
        }
      }).then((data) => {
        if (data) {
          if (data.data.res != undefined) {
            var obj = Object.keys(data.data)[0]
          } else {
            var obj = Object.keys(data.data)[0]
          }

          if (obj == "errors") {

            let arr = Object.values(data.data)[0]
            Object.values(arr).forEach(element => {
              toastr.error(element[0], "Error")
            })

          }
          if (obj == "success") {
            this.commit('getCartFidaliti')
            localStorage.getItem('lang') == 'fr' ? toastr.success("Carte de fidélité ajoutée avec succès", "succès") : toastr.success("تم إضافة بطاقة الولاء بنجاح ", "نجاح")
          }
        }

      }, () => {
        localStorage.getItem('lang') == 'fr' ? toastr.error("Une erreur s'est produite lors du processus d'ajout", "Erreur") : toastr.error("حدث خطأ أثناء عملية الإضافة ", "خطأ")
      })
    },
    addDemandCartFidaliti(state, data) {
      axios.post(USER_BACKEND_URL + "getUsers/addDemandCartFidaliti", data).then((data) => {
        if (data) {
          if (data.data.res != undefined) {
            var obj = Object.keys(data.data)[0]
          } else {
            var obj = Object.keys(data.data)[0]
          }
          if (obj == "errors") {
            let arr = Object.values(data.data)[0]
            Object.values(arr).forEach(element => {
              toastr.error(element[0], "Error")
            })

          }
          if (obj == "success") {
            localStorage.getItem('lang') == 'fr' ? toastr.success("Carte de fidélité demandée avec succès", "succès") : toastr.success("تم إضافة بطاقة الولاء بنجاح ", "نجاح")
          }
        }

      }, () => {
        localStorage.getItem('lang') == 'fr' ? toastr.error("Une erreur s'est produite lors du processus de demande", "Erreur") : toastr.error("حدث خطأ أثناء عملية الإضافة ", "خطأ")
      })
    }, 
    getUsers(state, data) {
      state.isLoadings = true
      axios.post(USER_BACKEND_URL + "getProfile", {
        id: localStorage.getItem('HU88fd9DFDFJIJJDFD')
      }, {
        headers: {
          "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
        }
      }).then((res) => {
        state.users = res.data
        state.isLoadings = false
      })
    },
    getUsersLabels(state, data) {
      state.isLoading = true
      axios.get(USER_BACKEND_URL + 'getUsersLabels').then(res => {
        state.usersForSite = res.data
        state.isLoading = false
      })
    },
    getDemandes(state, data) {
      axios.post(BACKEND_URL + "getDemandes", {
        domainName: document.location.origin
      }, {
        headers: {
          "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
        }
      }).then((res) => {
        state.demande = res.data
      })
    },
    getQuastion(state, data) {
      axios.post(BACKEND_URL + "getQuastion", {
        domainName: document.location.origin
      }, {
        headers: {
          "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
        }
      }).then((res) => {
        state.quastion = res.data
      })
    },
    login(state, arr) { // Login To The Contnrol Panel 
      state.isLoadings = true
      Fire.$Login(BACKEND_URL + 'login', arr).then((res) => {
        state.access_token = res.data.access_token
        state.isLogin = true
        state.isLoadings = false
      }).catch((err) => {
        this.isLogin = false
        state.isLoadings = false
      })
    },
    loginWithNip(state, arr) { // Login To The Contnrol Panel 
      state.isLoadings = true
      Fire.$LoginWithNip(USER_BACKEND_URL + 'loginWithNip', arr).then((res) => {
        state.access_token_with_nip = res.data.access_token
        state.isLoginWithNip = true
        state.isLoadings = false
        this.commit('getResultWithNip')
      }).catch((err) => {
        this.isLoginWithNip = false
        state.isLoadings = false
      })
    },
    logout(state) { // Logout from the control panel
      Fire.$LogOut(USER_BACKEND_URL + 'logout').then(res => {
        state.access_token = null
        state.isLogin = false
      })
    },
    logoutWithNip(state) { // Logout from the control panel
      localStorage.removeItem('IJIFS7854KOKSDOKO')
      localStorage.removeItem('POEJUGUR74SFJOJOG')
      localStorage.removeItem('GRRSGOIGDRGOOKOOF')
      state.access_token_with_nip = null
      state.isLoginWithNip = false
      this.commit('getDataWebsite')
    },
    searchPost(state, data) {
      axios.post(BACKEND_URL + 'searchPost', data).then(res => {
        state.news = res.data
      })
    },
    getGaleiItem(state, data) { // Get Galeri Part From Backend For Galeri Page
      this.isLoadings = true
      axios.post(BACKEND_URL + 'getGaleiItem', {
        domainName: document.location.origin
      }).then((res) => {
        state.galeriItem = res.data
        state.isLoadings = false
      })
    },
    signePDF(state, data) {
      Fire.$swal({
        title: localStorage.getItem('lang') == 'fr' ? 'Voulez-vous signer le fichier?' : 'هل تريد توقيع الملف؟',
        icon: localStorage.getItem('lang') == 'fr' ? 'question' : 'سؤال',
        iconHtml: '?',
        confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui' : 'نعم',
        cancelButtonText: localStorage.getItem('lang') == 'fr' ? 'Non' : 'لا',
        showCancelButton: true,
        showCloseButton: true
      }).then((result) => {
        if (result.value) {
          state.isLoadings = true
          axios.post(USER_BACKEND_URL + 'getUsers/signePdf', data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
            }
          }).then((data) => {
            if (data) {
              if (data.data.res != undefined) {
                var obj = Object.keys(data.data)[0]
              } else {
                var obj = Object.keys(data.data)
              }
              if (obj == "success") {
                state.isLoadings = false
                this.commit('getResult')
                Fire.$swal(
                  localStorage.getItem('lang') == 'fr' ? 'Action de signer.' : 'إجراء للتوقيع.',
                  localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
                );
                toastr.success(Object.values(data.data), Object.keys(data.data));
                res(data.data)
              } else if (obj == "Warning") {
                state.isLoadings = false
                toastr.warning(Object.values(data.data), Object.keys(data.data));

              }
            }
          })

        }

      })

    },

    deleteResult(state, data) {
      Fire.$swal({
        title: localStorage.getItem('lang') == 'fr' ? 'Êtes-vous sûr?' : 'هل انت متأكد؟',
        text: localStorage.getItem('lang') == 'fr' ? "Vous ne pourrez pas revenir en arrière!" : 'لن تتمكن من العودة!',
        icon: localStorage.getItem('lang') == 'fr' ? 'warning' : 'تحذير',
        showCancelButton: false,
        confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui, supprimez-le!' : 'نعم ، احذفه!'
      }).then((result) => {
        if (result.value) {
          axios.post(USER_BACKEND_URL + 'getResult/delete', data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
            }
          }).then((data) => {
            this.commit('getResult')
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getResult')
          }).catch((erre) => {
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getResult')
          });

        }
      })
    },
    deleteCartFidaliti(state, data) {
      Fire.$swal({
        title: localStorage.getItem('lang') == 'fr' ? 'Êtes-vous sûr?' : 'هل انت متأكد؟',
        text: localStorage.getItem('lang') == 'fr' ? "Vous ne pourrez pas revenir en arrière!" : 'لن تتمكن من العودة!',
        icon: localStorage.getItem('lang') == 'fr' ? 'warning' : 'تحذير',
        showCancelButton: false,
        confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui, supprimez-le!' : 'نعم ، احذفه!'
      }).then((result) => {
        if (result.value) {
          axios.post(USER_BACKEND_URL + 'getCartFidaliti/deleteCartFidaliti', data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO')}`
            }
          }).then((data) => {
            this.commit('getCartFidaliti')
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getCartFidaliti')
          }).catch((erre) => {
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getCartFidaliti')
          });

        }
      })
    },
    deleteQuestion(state, data) {
      Fire.$swal({
        title: localStorage.getItem('lang') == 'fr' ? 'Êtes-vous sûr?' : 'هل انت متأكد؟',
        text: localStorage.getItem('lang') == 'fr' ? "Vous ne pourrez pas revenir en arrière!" : 'لن تتمكن من العودة!',
        icon: localStorage.getItem('lang') == 'fr' ? 'warning' : 'تحذير',
        showCancelButton: false,
        confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui, supprimez-le!' : 'نعم ، احذفه!'
      }).then((result) => {
        if (result.value) {
          axios.post(BACKEND_URL + 'getQuastion/deleteQuestion', data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
            }
          }).then((data) => {
            this.commit('getQuastion')
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getQuastion')
          }).catch((erre) => {
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getQuastion')
          });

        }
      })
    },
    deleteMessage(state, data) {
      Fire.$swal({
        title: localStorage.getItem('lang') == 'fr' ? 'Êtes-vous sûr?' : 'هل انت متأكد؟',
        text: localStorage.getItem('lang') == 'fr' ? "Vous ne pourrez pas revenir en arrière!" : 'لن تتمكن من العودة!',
        icon: localStorage.getItem('lang') == 'fr' ? 'warning' : 'تحذير',
        showCancelButton: false,
        confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui, supprimez-le!' : 'نعم ، احذفه!'
      }).then((result) => {
        if (result.value) {
          axios.post(BACKEND_URL + 'getMessage/deleteMessage', data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
            }
          }).then((data) => {
            this.commit('getMessage')
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getMessage')
          }).catch((erre) => {
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
            this.commit('getMessage')
          });

        }
      })
    },
    deleteDemande(state, data) {
      Fire.$swal({
        title: localStorage.getItem('lang') == 'fr' ? 'Êtes-vous sûr?' : 'هل انت متأكد؟',
        text: localStorage.getItem('lang') == 'fr' ? "Vous ne pourrez pas revenir en arrière!" : 'لن تتمكن من العودة!',
        icon: localStorage.getItem('lang') == 'fr' ? 'warning' : 'تحذير',
        showCancelButton: false,
        confirmButtonText: localStorage.getItem('lang') == 'fr' ? 'Oui, supprimez-le!' : 'نعم ، احذفه!'
      }).then((result) => {
        if (result.value) {
          axios.post(BACKEND_URL + 'getDemandes/deleteDemande', data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Authorization": `Bearer ${ localStorage.getItem('ADSDIS458SZDF54S7')}`
            }
          }).then((data) => {
            this.commit('getDemandes')
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );

          }).catch((erre) => {
            console.log('erre', erre)
            Fire.$swal(
              localStorage.getItem('lang') == 'fr' ? 'Action de supprimer.' : 'حذف الإجراء.',
              localStorage.getItem('lang') == 'fr' ? 'Succès' : 'نجاح'
            );
          });

        }
      })
    },

    getResult(state, data) { // Get Result Part From Mesanalyses API
      this.isLoadings = true
      axios.post(USER_BACKEND_URL + 'getResult2', {
        id: localStorage.getItem("HU88fd9DFDFJIJJDFD")
      }, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('AZDFDdsSDSJ21SSDO') }`
        }
      }).then((res) => {
        state.result = res.data
        state.isLoadings = false
      })
    },
    getResultWithNip(state, data) { // Get Result Part From Mesanalyses API
      this.isLoadings = true
      var res = localStorage.getItem('GRRSGOIGDRGOOKOOF').valueOf()
      axios.post(USER_BACKEND_URL + 'getResultWithNip', {
        id: res.match(/458(.*)H7F7F4/)[1]
      }, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('IJIFS7854KOKSDOKO') }`
        }
      }).then((res) => {
        state.resultwithNip = res.data
        state.isLoadings = false
      })
    },
    getCartFidaliti(state, data) { // Get Result Part From Mesanalyses API
      this.isLoadings = true
      axios.post(USER_BACKEND_URL + 'getCartFidaliti', {
        domainName: document.location.origin
      }, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('AZDFDdsSDSJ21SSDO') }`
        }
      }).then((res) => {
        state.cartFidaliti = res.data
        state.isLoadings = false
      })
    },
    getNews(state, data) {
      this.isLoadings = true
      axios.post(BACKEND_URL + 'getNews', {
        domainName: document.location.origin
      }).then((res) => {
        state.news = res.data
        state.isLoadings = false
      })
    },
    async getDataWebsite(state) { // Get All Data From Backend For Website
      this.isLoadings = true
      let {
        data
      } = await axios.post(BACKEND_URL + 'getDataWebsite', {
        domainName: document.location.origin
      })

      state.website = data
      state.isLoadings = false


    },
    getBarItems(state, data) { // Get All Pages From Backend For Website
      this.isLoadings = true
      axios.post(BACKEND_URL + 'getBarItems', {
        domainName: document.location.origin
      }).then((res) => {
        state.pages = res.data
        state.isLoadings = false
      })
    },
    getStatus(state, data) { // Get Sections Status From Backend For Website
      this.isLoadings = true
      axios.post(BACKEND_URL + 'getStatus', {
        domainName: document.location.origin
      }).then((res) => {
        state.status = res.data
        state.isLoadings = false
      })
    },
    getSection(state, data) { // Get Sections Status From Backend For Website
      this.isLoadings = true
      axios.get(BACKEND_URL + 'getSection').then((res) => {
        state.sections = res.data
        state.isLoadings = false
      })
    },
    changeProfil(state, data) {
      state.isLoading = true
      axios.post(USER_BACKEND_URL + 'getUsers/changeProfile', data, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": `Bearer ${ localStorage.getItem('AZDFDdsSDSJ21SSDO') }`
        },
        transformRequest: [function (dat, headers) {
          return objectToFormData(dat)
        }],
        onUploadProgress: e => {}
      }).then((data) => {

        if (data) {
          if (data.data.res != undefined) {
            var obj = Object.keys(data.data)[0]
          } else {
            var obj = Object.keys(data.data)[0]
          }
          if (obj == "success") {
            var user = Object.values(data.data)[1][0]
            state.isLoading = false

            localStorage.setItem("HUDS45DSSKCVZEZFG", user.fullname)
            localStorage.setItem("LMLVCVPPIDFDdKOSDS", user.fullnameArab)

            localStorage.getItem('lang') == 'fr' ? toastr.success("Les informations ont été mises à jours", "succès") : toastr.success("تم تحديث المعلومات", "نجاح")
            this.commit('getUsers')
            res(data.data)
          } else if (obj == "Error") {
            console.log(obj);
            state.isLoading = false
            toastr.error(Object.values(data.data), Object.keys(data.data));
          } else if (obj == "Warning") {
            console.log(obj);
            state.isLoading = false
            toastr.warning(Object.values(data.data), Object.keys(data.data));

          } else {
            state.isLoading = false
            var arr = Object.values(data.data)[0]
            console.log(arr);

            Object.values(arr).forEach(element => {
              toastr.error(element[0], "Error")
            });
            rej(arr)
          }
        }

      })
    },
  },
  actions: {
    login({
      commit
    }, arr) {
      commit('login', arr)
    },
    logout({
      commit
    }, arr) {
      commit('logout', arr)
    },
    logoutWithNip({
      commit
    }, arr) {
      commit('logoutWithNip', arr)
    },
    getGaleiItem({
      commit
    }, arr) {
      commit('getGaleiItem', arr)
    },
    getNews({
      commit
    }, arr) {
      commit('getNews', arr)
    },
    getDataWebsite({
      commit
    }, arr) {
      commit('getDataWebsite', arr)
    },
    getStatus({
      commit
    }, arr) {
      commit('getStatus', arr)
    },
    loginWithNip({
      commit
    }, arr) {
      commit('loginWithNip', arr)
    },
    getBarItems({
      commit
    }, arr) {
      commit('getBarItems', arr)
    },
    getSection({
      commit
    }, arr) {
      commit('getSection', arr)
    },
    searchPost({
      commit
    }, arr) {
      commit('searchPost', arr)
    },
    getResult({
      commit
    }, arr) {
      commit('getResult', arr)
    },
    getResultWithNip({
      commit
    }, arr) {
      commit('getResultWithNip', arr)
    },
    signePDF({
      commit
    }, arr) {
      commit('signePDF', arr)
    },
    deleteResult({
      commit
    }, arr) {
      commit('deleteResult', arr)
    },
    deleteQuestion({
      commit
    }, arr) {
      commit('deleteQuestion', arr)
    },
    deleteDemande({
      commit
    }, arr) {
      commit('deleteDemande', arr)
    },
    getQuastion({
      commit
    }, arr) {
      commit('getQuastion', arr)
    },
    deleteMessage({
      commit
    }, arr) {
      commit('deleteMessage', arr)
    },
    getDemandes({
      commit
    }, arr) {
      commit('getDemandes', arr)
    },
    getCartFidaliti({
      commit
    }, arr) {
      commit('getCartFidaliti', arr)
    },
    deleteCartFidaliti({
      commit
    }, arr) {
      commit('deleteCartFidaliti', arr)
    },
    saveCartFidaliti({
      commit
    }, arr) {
      commit('saveCartFidaliti', arr)
    },
    addDemandCartFidaliti({
      commit
    }, arr) {
      commit('addDemandCartFidaliti', arr)
    },
    virifyEmail({
      commit
    }, arr) {
      commit('virifyEmail', arr)
    },
    getMessage({
      commit
    }, arr) {
      commit('getMessage', arr)
    },
    getUsers({
      commit
    }, arr) {
      commit('getUsers', arr)
    },
    getUsersLabels({
      commit
    }, arr) {
      commit('getUsersLabels', arr)
    },
    getCommune({
      commit
    }, arr) {
      commit('getCommune', arr)
    },
    getWilaya({
      commit
    }, arr) {
      commit('getWilaya', arr)
    },
    getSettings({
      commit
    }, arr) {
      commit('getSettings', arr)
    },
    getItemBarNew({
      commit
    }, arr) {
      commit('getItemBarNew', arr)
    },
    changeProfil({
      commit
    }, arr) {
      commit('changeProfil', arr)
    },
    sendResponse({
      commit
    }, arr) {
      commit('sendResponse', arr)
    },
  }
})